import React from "react";
import { Grid2, Card, CardContent, Typography, Box } from "@mui/material";
import { ReactComponent as ArrowIcon } from "../../icons/arrowGray.svg";
import makeStyles from "@mui/styles/makeStyles";
import { colorSystem } from "../../theme";
import MinimizedTooltip from "../tooltip/MinimizedTooltip";
import { AddedLozenge } from "../item/AddedLozenge";

const useStyles = makeStyles((theme) => ({
  container: {
    boxShadow: "none",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colorSystem.gray7,
    borderRadius: 12,
    padding: 20,
    cursor: "pointer",
  },
  exercises: {
    padding: `${theme.spacing(0)} !important`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  arrow: {
    transform: "rotate(90deg)",
  },
  text: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: "20px",
  },

  lozenge: {
    padding: theme.spacing(0.5, 1.5),
    height: 22,
    "& > *": {
      fontSize: 14,
    },
    alignItems: "center",
    margin: 0,
    border: `2px solid ${theme.palette.warning.light}`,
  },

  textWithBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.8),
    flexWrap: "wrap",
  },
}));

type ClientExercisesItemProps = {
  name: string;
  onClick: () => void;
  isObsolete: boolean;
};

const ClientExercisesItem = ({
  name,
  onClick,
  isObsolete,
}: ClientExercisesItemProps) => {
  const s = useStyles();
  return (
    <Grid2
      size={{
        xs: 12,
        sm: 6,
        md: 4,
      }}
    >
      <Card className={s.container} onClick={onClick}>
        <CardContent className={s.exercises}>
          <Box className={s.textWithBadge}>
            <Typography className={s.text}>{name}</Typography>
            {isObsolete && (
              <MinimizedTooltip
                children={
                  <AddedLozenge text={"Obsolete"} className={s.lozenge} />
                }
                title={"This exercise was renamed or deleted by the coach."}
                opacity={1}
              />
            )}
          </Box>
          <ArrowIcon className={s.arrow} />
        </CardContent>
      </Card>
    </Grid2>
  );
};

export default ClientExercisesItem;
